<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div v-loading="RiskLoding">
    <gui_card id="ge6845" class="country_card" label="" :isShowLabel="false">
      <div>
        <h2 class="operations-head-content">
          <span class="operations-headspan"
            >{{ $t("TradeByCountry.CountryData") }}
          </span>
        </h2>
        <div class="flex_center_between_box">
          <div class="nation_table">
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.GDP") }}</span
              >{{ CountryObj?.gdp || "-" }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan"
                >{{ $t("TradeByCountry.GDPPPP") }}</span
              >
              {{ CountryObj?.realGdp || "-" }}
            </p>
            <!-- <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.NominalGNI") }}:</span
              >{{ CountryObj?.nominalGni }}
            </p> -->
            <p class="CountryUsd">
              <span class="CountryUsdspan"
                >{{ $t("TradeByCountry.ExportsofGoods") }}</span
              >{{ CountryObj?.exportGoods || "-" }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan"
                >{{ $t("TradeByCountry.ExportsofServices") }}</span
              >{{ CountryObj?.exportServices || "-" }}
            </p>
            <!-- <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.Ecommercesales") }}:</span
              >{{ CountryObj?.ecommerceSales }}
            </p> -->
            <p class="CountryUsd">
              <span class="CountryUsdspan"
                >{{ $t("TradeByCountry.ImportsofGoods") }}</span
              >{{ CountryObj?.importGoods || "-" }}
            </p>
          </div>
          <div class="nation_table">
            <p class="CountryUsd">
              <span class="CountryUsdspan"
                >{{ $t("TradeByCountry.ImportsofServices") }}</span
              >{{ CountryObj?.importServices || "-" }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.CPI") }}</span
              >{{ CountryObj?.cpi || "-" }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan"
                >{{ $t("TradeByCountry.Productivecapacitiesindex") }}</span
              >{{ CountryObj?.productiveCapacitiesIndex || "-" }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{
                $t("TradeByCountry.Population")
              }}</span
              >{{ CountryObj?.totalPopulation || "-" }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan"
                >{{ $t("TradeByCountry.ContainerPortThroughput") }}</span
              >{{ CountryObj?.containerPortThroughput || "-" }}
            </p>
          </div>
        </div>
      </div>
    </gui_card>
    <Map class="country_card"></Map>
    <CompanyBar></CompanyBar>
    <TradeTrends></TradeTrends>

    <gui_card id="ge6845" label="" :isShowLabel="false">
      <div  class="operations-content">
        <h2 class="operations-head-content">
          <span class="operations-headspan" 
            >{{ $t("TradeByCountry.CountryImportExportOverview") }}
          </span>
          <!-- <el-date-picker v-model="datePicker" @change="SelectPicker" :readonly="true" style="width: 20rem;height: 3.571428rem;"
          type="years" range-separator="" start-placeholder="Start date" value-format="yyyy-MM"
          end-placeholder="End date"></el-date-picker> -->
          <!-- <el-select
            v-model="dateImportPicker"
            multiple
            :multiple-limit="2"
            placeholder=""
            @change="SelectPicker"
            class="date_import_picker"
          >
            <el-option
              v-for="item in Yearoptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select> -->

          <div>
            <div v-show="false">{{ calDate }}</div>
            <el-date-picker
              class="limitDate"
              v-model="beginDate"
              type="year"
              :placeholder="$t('SearchTrade.Startdate')"
              value-format="yyyy"
              :picker-options="beginPickerOptions"
            />
            <span class="font16 margin-left15 margin-right15">To</span>
            <el-date-picker
              class="limitDate"
              v-model="endDate"
              type="year"
              :placeholder="$t('SearchTrade.Enddate')"
              value-format="yyyy"
              :picker-options="endPickerOptions"
            /> 
          </div>
        </h2>
        <div class="flex_center_between_box">
          <div class="Products_lesft" style="height: auto; width: 100%">
            <div ref="SupplyChainEchart" style="width: 98%; height: 100%"></div>
          </div>
          <div class="table-biao table-biao-left" style="position: relative">
            <el-table
              :data="importTableData"
              ref="table"
              :empty-text="$t('SearchTrade.NoData')"
              class="table_height_30 table_contentHeight_40"
            >
              <el-table-column
                prop="date"
                :label="$t('TradeByCountry.Year')"
                align="left"
                width="100"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span class="table-content">{{ scope.row.date }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop="amount"
                :label="$t('TradeByCountry.Amount')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span
                    :class="
                      scope.row?.amount?.includes('-')
                        ? ' table-contentred'
                        : ' table-contentGree'
                    "
                  >
                    {{ scope.row.amount | FilterNum }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                prop="amount"
                :label="$t('TradeByCountry.Balance')"
                align="left"
                show-overflow-tooltip
              >
                <template slot-scope="scope">
                  <span> {{ scope.row.balanceDirection }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
    </gui_card>

    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import { formatNum } from "@/views/company/details/Background/utils";

import {
  showTradeDataTrends,
  showCountryTradeData,
  selectHasDataYears,
  getNationalData,
} from "@/api/companyApi.js";
import rectcard from "@/components/rectCard/index.vue";
import content_text from "@/components/text_content/index.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import gui_card from "@/components/gui_card/gui_card.vue";
import Map from "../tradeMap/mapTree.vue";
import TradeTrends from "../TradeTrends/indextree.vue";
import CompanyBar from "./CompanyBar.vue";
import { nextTick } from "vue";
export default {
  name: "",
  // props: {},
  components: {
    gui_card,
    CompanyBar,
    Map,
    rectcard,
    content_text,
    ReLogin,
    TradeTrends,
  },
  data() {
    return {
      data: {
        links: [],
        nodes: [],
      },
      Importyear: "2023",
      Yearoptions: [], 
      dateImportPicker: [],
      Exportyear: "2024",
      activeIEports: "Imports",
      CountryObj: {},
      RiskLoding: false,
      ExporttableData: [],
      importTableDataRaw: [],
      reLoginVis: false,
      NationalDataObj: {},

      
        beginDate: "",
      endDate: "",
        beginPickerOptions: {
        disabledDate: (time) => {
          if (!this.endDate) return false
          return time.getTime() > new Date(this.endDate).getTime()
        }
      },

      endPickerOptions: {
        disabledDate: (time) => {
          if (!this.beginDate) return false
          return time.getTime() < new Date(this.beginDate).getTime()
        }
      },
    };
  },
  watch: {
    dateImportPicker: {
      handler(newVal, oldVal) {
          this.getmportData();
        },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    this.$emit("UpdatamarkTotalList", true);

    this.getselectHasDataYears();
    this.getNationalDataList();
  },
  computed: {  
    calDate() {
      this.dateImportPicker = [this.beginDate, this.endDate];
      return this.dateImportPicker;
    },
    importTableData() {
      // 对原始数据按照 date 字段进行倒序排序
      return this.importTableDataRaw
        .slice() // 创建副本避免修改原始数据
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    },
  },
  methods: {
    getNationalDataList() {
      this.RiskLoding = true;

      getNationalData({
        countryCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.CountryObj = res.data;
          this.RiskLoding = false;
        } else {
          this.RiskLoding = false;
        }
      });
    },
    getselectHasDataYears() {
      selectHasDataYears({
        country: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.Yearoptions = res.data;
          this.Importyear = res.data[0].value;
          this.endDate = res.data[0].value;
          var la = res.data.length - 1;
          this.beginDate= "";
          this.beginDate= res.data[la].value;

          this.getmportData();
        } else {
          this.Yearoptions = [];
        }
      });
    },
    ceckIEports(row) {
      this.activeIEports = row;
    },
    default() {},

    ChangeEcportDate() {
      this.getexportData();
    },

    SelectPicker() {
      this.dateImportPicker = this.dateImportPicker.sort(function (a, b) {
        return a - b;
      });
      this.getmportData();
    },
    getmportData() {
      showTradeDataTrends({
        country: this.$route.query.id3a,
        startYear: this.dateImportPicker[0],
        endYear: this.dateImportPicker[1],
      }).then((res) => {
        if (res.code == 200) {
          this.importTableDataRaw = res.data;
        }
        this.suppleEchart();
      });
    },
    

    suppleEchart() {
      let that = this;

      this.echartsBox = this.$echarts.init(this.$refs.SupplyChainEchart);

      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          left: "0%", // 设置左侧边距
          right: "0%",
          top: "12%",
          bottom: "0%",
          containLabel: true,
        },
        legend: {
          right: "10px",
          top: "0px",
          //  width: '200px'
          // 其他图例配置项
          // ...
        },
        xAxis: {
          type: "category",
          data: that.importTableDataRaw.map((item) => item.date),
          axisTick: {
            show: false, // 不显示 x 轴上的间隔点
          },
          axisLine: {
            show: true,
            lineStyle: {
              width: 1,

              color: "#8497AB",
            },
          },
          axisLabel: {
            color: "#1A2332", // 设置字体颜色
            fontSize: 14, // 可以在这里设置字体大小
            fontWeight: "normal", // 字体粗细
            fontFamily: "Arial , Arial ", // 字体类型,
          },
        },
        yAxis: [
          {
            type: "value",
            // splitNumber: 4,
            // inverse: true,
            axisLine: {
              show: true,
              // 横坐标轴颜色
              lineStyle: {
                width: 1,

                color: "#8497AB",
              },
            },
            // 背景虚线
            splitLine: {
              lineStyle: {
                width: 1,
                type: "dashed",
                color: "#8398BB",
              },
            },
            axisLabel: {
              color: "#1A2332", // 设置字体颜色
              fontSize: 14, // 可以在这里设置字体大小
              fontWeight: "normal", // 字体粗细
              fontFamily: "Arial , Arial ", // 字体类型,
              formatter: function (value) {
                return formatNum(value); // 格式化为千分位
              },
            },
          },

          {
            type: "value",
            // position: 'right',
          },
        ],
        series: [
          {
            name: this.$t("TradeByCountry.TotalImportAmount"),
            type: "bar",
            barWidth: "30",
            itemStyle: {
              color: "#009EA7",
              barBorderRadius: [5, 5, 0, 0], // [左上角, 右上角, 右下角, 左下角]
            },
            emphasis: {
              itemStyle: {
                color: "#009EA7",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return "USD " +  formatNum(value);
                } else {
                  return "-";
                }
              },
            },
            data: that.importTableDataRaw.map((item) => item.totalImport),
          },
          {
            name: this.$t("TradeByCountry.TotalExportAmount"),
            type: "bar",
            barWidth: "30",
            itemStyle: {
              color: "#FF7600",
              barBorderRadius: [5, 5, 0, 0], // [左上角, 右上角, 右下角, 左下角]
            },
            emphasis: {
              itemStyle: {
                color: "#FF7600",
              },
            },
            tooltip: {
              valueFormatter: function (value) {
                if (value != null) {
                  return "USD " + formatNum(value);
                } else {
                  return "-";
                }
              },
            },
            data: that.importTableDataRaw.map((item) => item.totalExport),
          },
        ],
      };
      this.echartsBox.setOption(option);
      this.$nextTick(() => {
        this.echartsBox.resize();
      });
    },
  },
};
</script>
<style scoped>
.operations-headspan {
  color: #009ea7;
}

.importDetail-head {
  display: flex;
}

.table-biao {
  height: auto;
  overflow-y: auto;
  background: #ffffff;
  margin-left: 30px;
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

/deep/ .el-table .cell {
  color: #1a2332;
  font-family: "Arial  Bold";
}

/deep/ .highlight-cell {
  background-color: #f2f5f9 !important;
}

/deep/ .el-table th.el-table__cell {
  background-color: #f2f5f9 !important;
  font-family: "Arial  Bold";
}

#cb02bf {
  padding-bottom: 1.4285714285714286rem;
}

.contclass {
  font-size: 1.4285714285714286rem;
  color: #1290c9;
  font-style: normal;
}

.table_add {
  display: flex;
  justify-content: center;
  align-items: center;
}

.table_add_Text {
  font-family: "Arial  Bold";
  text-align: left;
}

.table-content {
  color: #1a2332;
  display: inline-block;
  line-height: 30px;
}

.country_card {
  height: 100%;
}

.impact_status {
  width: 2.2857142857142856rem;
  height: 2.2857142857142856rem;
  text-align: center;
  border-radius: 50%;
}

.impact_status img {
  width: 1.1428571428571428rem;
  height: 1.1428571428571428rem;
  margin-top: 0.5rem;
}

.impact_status.green {
  background: #55b419;
}

.impact_status.hui {
  background: #ccc;
}

.impact_status.blue {
  background: #1290c9;
}

.impact_status.red {
  background: #ff7600;
}

.input-str {
  position: absolute;
  top: 0.2857142857142857rem;
  left: 13.214285714285714rem;
  z-index: 99;
  text-align: 7.142857142857143rem;
  width: 26%;
}

.input-str /deep/ .el-input__inner {
  margin-top: -0.14285714285714285rem;
}

/deep/.el-input__inner:focus {
  border: 0.07142857142857142rem solid #8497ab;
}
.Products_lesft {
  width: 69%;
}

.table-biao {
  width: 410px;
  flex: none;
}
.CountryUsd {
  width: 100%;
  color: #1a2332;
  font-size: 18px;
  line-height: 30px;
  display: flex;
  border-bottom: 1px solid #cccccc;
  align-items: center;
}
.CountryUsdspan {
  font-family: "Arial Bold";
  width: 305px;
  background: #f2f5f9;
  height: 100%;
  display: flex;
  align-items: center;
  padding: 15px 0px 15px 20px;
  margin-right: 40px;
}
.table-biao-left /deep/ .el-table td.el-table__cell {
  border-right: none;
}
.date_import_picker /deep/ .el-tag.el-tag--info {
  background-color: #fff !important;
  border-color: #fff !important;
  color: #1a2332;
  font-size: 20px;
  width: 42%;
  text-align: center;
}
.date_import_picker /deep/ .el-select__tags {
  top: 32%;
}
.date_import_picker /deep/ .el-select__tags-text {
  width: 100%;
}
/deep/ .el-icon-close {
  display: none !important;
}

.table-contentred {
  color: #f56b6b !important;
}
.table-contentGree {
  color: #009ea7 !important;
}
.nation_table {
  width: 50%;
  border-top: 1px solid #cccccc;
}
.date_import_picker /deep/ .el-tag.el-tag--info:first-child::after {
  content: "to";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 25px;
  padding: 0 5px;
  background-color: #fff;
  margin-left: -18px;
}
.date_import_picker /deep/ .el-tag.el-tag--info:last-child {
  margin-left: 15px;
}
.date_import_picker >>> .el-input--suffix .el-input__inner {
  width: 410px;
  height: 36px !important;
}
.font26 {
  font-size: 26px !important;
}

.limitDate {
  width: 200px;
}
@media screen and (max-width: 1920px) {
  .contclass {
    font-size: 14px;
  }
  .CountryUsd {
    font-size: 16px;
    line-height: 22px;
  }
  .CountryUsdspan {
    width: 250px;
    padding: 12px 0px 12px 15px;
    margin-right: 30px;
  }
  .table-content {
    line-height: 22px;
  }
  .table-biao {
    width: 350px;
    margin-left: 22px;
  }
  .date_import_picker /deep/ .el-tag.el-tag--info {
    font-size: 14px;
  }
  .date_import_picker /deep/ .el-tag.el-tag--info:first-child::after {
    margin-left: -10px;
  }
  .date_import_picker >>> .el-input--suffix .el-input__inner {
    width: 350px;
    height: 32px !important;
  }
  .date_import_picker /deep/ .el-select__tags {
    top: 40%;
  }
  .font26 {
    font-size: 20px !important;
  }
  .limitDate {
  width: 150px;
}
}
@media screen and (max-width: 1439px) {
  .contclass {
    font-size: 14px;
  }
  .CountryUsd {
    font-size: 14px;
    line-height: 20px;
  }
  .CountryUsdspan {
    width: 204px;
    padding: 10px 0px 10px 13px;
    margin-right: 26px;
  }
  .table-content {
    line-height: 20px;
  }
  .table-biao {
    width: 350px;
    margin-left: 20px;
  }
  .date_import_picker /deep/ .el-tag.el-tag--info {
    font-size: 16px;
  }
  .date_import_picker /deep/ .el-tag.el-tag--info:first-child::after {
    margin-left: -10px;
  }
  .date_import_picker >>> .el-input--suffix .el-input__inner {
    height: 32px !important;
    width: 350px;
  }

  .font26 {
    font-size: 18px !important;
  }
  .limitDate {
  width: 120px;
}
}
</style>
